import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { validateFiled } from "../../validation";


function Login(props) {
  const [activeModal, setActiveModal] = useState("login");
  const [currentStep, setCurrentStep] = useState(1);
	const [formData, setFormData] = useState({
	  currency: "BDT",
  });
  const [errors, setErrors] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [apiMessage, setApiMessage] = useState("");
  const navigate = useNavigate();
  const affiliateCode = localStorage.getItem('affiliate_code');
	const referralCode = localStorage.getItem('referral_code');
	const { setSwalProps } = props;
	
	const rules = {
		username: ["required", "min:5", "max:18"],
		password: ["required", "password"],
		confirm_password: ["required", "password", "confirm_password"],
		first_name: ["required"],
		last_name: ["required"],
		dofb: ["required",'age'],
		phone: ["required"],
		email: ["required", "email"],
		currency: ["required"],
		contract_type: ["required"],
		opt: ["required","min:6","max:6"],
	};

  useEffect(() => {
    if (referralCode) {
      setFormData(prevData => ({ ...prevData, referral_code: referralCode }));
    } else {
      setFormData(prevData => ({ ...prevData, referral_code: affiliateCode }));
	  }
  }, [referralCode, affiliateCode]);

  const openSignup = () => {
    setActiveModal("register");
    setCurrentStep(1);
    setErrors({});
    setValidationErrors({});
    setApiMessage("");
  };

  const openLogin = () => {
    setActiveModal("login");
    setErrors({});
  };

  const openForgotPassword = () => {
    setActiveModal("forgotPassword");
    setErrors({});
  };

  const handleNext = () => {
    const isValid = validateStep(currentStep);
    if (isValid) {
      setCurrentStep((prev) => Math.min(prev + 1, 3));
    }
  };

	const handlePrevious = () => setCurrentStep((prev) => Math.max(prev - 1, 1));


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error for this field when user types
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: undefined
      });
	}
	  
	// get validation rules for the field
	const fieldRules = rules[name] || [];
	  if (fieldRules.length > 0) {
		fieldRules.forEach((rule, index) => {
			if (rule === "confirm_password") { 
				fieldRules[index] = rule + ":" + formData.password;
			}
		});
		let error = validateFiled(name, value, fieldRules);
		if (error) {
			setErrors({
				...errors,
				[name]: error
			});
		} else {
			setErrors({
				...errors,
				[name]: undefined
			});
		}
	}
  };


  const validateStep = (step) => {
    let valid = true;
	const newErrors = {};
	let stepRules = [];

    if (step === 1) {
		// Validate username
		stepRules = [
			'username',
			'password',
			'confirm_password',
			'currency'
		];
		
		stepRules.forEach((field) => {
			let fieldRules = rules[field] || [];
			fieldRules.forEach((rule, index) => {
				if (rule === "confirm_password") {
					fieldRules[index] = rule + ":" + formData.password;
				}
			});
			const value = formData[field] || "";
			const error = validateFiled(field, value, fieldRules);
			if (error) {
				newErrors[field] = error;
				valid = false;
			}
		});
      
	} else if (step === 2) {
	
		stepRules = [
			'first_name',
			'last_name',
			'dofb'
		];

		stepRules.forEach((field) => {
			const fieldRules = rules[field] || [];
			const value = formData[field] || "";
			const error = validateFiled(field, value, fieldRules);
			if (error) {
				newErrors[field] = error;
				valid = false;
			}
		});

      
	} else if (step === 3) {
		
		stepRules = [
			'phone',
			'email',
			'contract_type',
			'contract_value'
		];
		stepRules.forEach((field) => {
			const fieldRules = rules[field] || [];
			const value = formData[field] || "";
			const error = validateFiled(field, value, fieldRules);
			if (error) {
				newErrors[field] = error;
				valid = false;
			}
		});	
    }

    setErrors(newErrors);
    return valid;
  };

  const validateLogin = () => {
    let valid = true;
    const newErrors = {};

    // if (!formData.username || formData.username.trim() === "") {
    //   newErrors.username = "Username is required";
    //   valid = false;
    // }

    // if (!formData.password || formData.password.trim() === "") {
    //   newErrors.password = "Password is required";
    //   valid = false;
	// }
	  
	let stepRules = [
		'username',
		'password',
	];
	stepRules.forEach((field) => {
		const fieldRules = rules[field] || [];
		const value = formData[field] || "";
		const error = validateFiled(field, value, fieldRules);
		if (error) {
			newErrors[field] = error;
			valid = false;
		}
	});	

    setErrors(newErrors);
    return valid;
  };

  const validateForgotPassword = () => {
    let valid = true;
    const newErrors = {};
	
	let stepRules = [
		'email',
	];
	stepRules.forEach((field) => {
		const fieldRules = rules[field] || [];
		const value = formData[field] || "";
		const error = validateFiled(field, value, fieldRules);
		if (error) {
			newErrors[field] = error;
			valid = false;
		}
	});	

    setErrors(newErrors);
    return valid;
	};
	
	const validateChangePassword = () => {
		let valid = true;
		const newErrors = {};
		
		let stepRules = [
			'email',
			'otp',
			'password',
			'confirm_password'
		];

		stepRules.forEach((field) => {
			let fieldRules = rules[field] || [];
			fieldRules.forEach((rule, index) => {
				if (rule === "confirm_password") {
					fieldRules[index] = rule + ":" + formData.password;
				}
			});
			const value = formData[field] || "";
			const error = validateFiled(field, value, fieldRules);
			if (error) {
				newErrors[field] = error;
				valid = false;
			}
		});
	
		setErrors(newErrors);
		return valid;
	  };

  const handleSubmit = async (url, body, onSuccess) => {
	  try {
		  const response = await fetch(url, {
			  method: "POST",
			  headers: {
				  "Content-Type": "application/json",
			  },
			  body: JSON.stringify(body),
		  });
      
		  const data = await response.json();
		  console.log(data);
		  console.log(response.ok);

		  if (response.ok) {
			  setErrors({}); // Clear any errors
			  if (onSuccess) onSuccess(data);
		  } else {
			  // Handle Laravel validation errors (typically 422 status code)
			  if (data?.errors) {
				  // Laravel returns validation errors in the format: { errors: { field: [errorMessage] } }
				  const laravelErrors = {};
          
				  // Transform Laravel validation errors to match our format
				  let errorMsg = [];
				  Object.keys(data.errors).forEach(field => {
					  // Take the first error message for each field
					  laravelErrors[field] = data.errors[field][0];
					  errorMsg.push(data.errors[field][0]);
				  });
			
				  if (errorMsg.length > 0) {
					  setSwalProps({});
					  setTimeout(() => {
						  setSwalProps({
							  show: true,
							  title: "Ops!",
							  text: errorMsg.join("\n"),
							  icon: "error",
						  });
					  }, 20);
				  }

				  setErrors(laravelErrors); // Use setErrors instead of setValidationErrors
			  } else {
				  console.log("Error:", data);
				  if (data?.message) {
						setErrors({ general: data.message || data.error || "An error occurred." });
				  }
			  }
		  }
	  } catch (error) {
      setErrors({ general: "An error occurred. Please try again." });
    }
  };

  const submitLogin = () => {
    if (validateLogin()) {
      handleSubmit(
        "https://esgaming.online/api/affiliate-login",
        {
          username: formData.username,
          password: formData.password,
        },
        (data) => {
          localStorage.setItem("token", data.token);
          console.log(data.token);
          navigate("/");
        }
      );
    }
  };

  const submitSignup = () => {
    if (validateStep(3)) {
      handleSubmit(
        "https://esgaming.online/api/affiliate-signup",
        {
          username: formData.username,
          password: formData.password,
          confirm_password: formData.confirm_password,
          currency: formData.currency || "BDT",
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          phone: formData.phone,
          contract_type: formData.contract_type,
          contract_value: formData.contract_value,
          dofb: formData.dofb,
          referral_code: formData.referral_code,
          origin: window.location.origin,
        },
        (data) => {
			setApiMessage(data.message);
			setSwalProps({});
			setTimeout(() => {
				setSwalProps({
					show: true,
					title: "Success",
					text: data.message,
					icon: "success",
					timer: 5000,
				});
			}, 20);
          setActiveModal("login");
        }
      );
    }
	};
	
	const postChangePassword = () => {
		if (validateChangePassword()) {
			handleSubmit(
				"https://esgaming.online/api/affiliate-reset-password",
				{
					email: formData.email,
					otp: formData.otp,
					password: formData.password,
					confirm_password: formData.confirm_password,
				},
				(data) => {
					setApiMessage(data.message);
					setSwalProps({});
					setTimeout(() => {
						setSwalProps({
							show: true,
							title: "Success",
							text: "Password changed successfully.",
							icon: "success",
							timer: 2000,
						});
					}, 20);
					setActiveModal("login");
				}
			);
		}
	};

  const submitForgotPassword = () => {
    if (validateForgotPassword()) {
      handleSubmit(
        "https://esgaming.online/api/affiliate-forgot",
        {
          email: formData.email,
        },
        (data) => {
			setApiMessage(data.message);
			setSwalProps({});
			setTimeout(() => {
				setSwalProps({
					show: true,
					title: "OTP Sent",
					text: "Otp sent to your email.",
					icon: "success",
					timer: 2000,
				});
			}, 20);
          setActiveModal("otp_reset");
        }
      );
    }
  };

  // Helper functions for form validation UI
  const getFormGroupClass = (field) => {
	const value = formData[field] || "";
	  const isValid = !errors[field] && value.trim() !== "";
	  if (isValid) {
		return "form-group form-column is-valid";
	  } else {
		return `form-group form-column ${errors[field] ? "is-invalid" : ""}`;
	  }
  };

  const renderError = (field) => {
    if (errors[field]) {
      return <div className="invalid-feedback">{errors[field]}</div>;
    }
    return null;
  };

  return (
	  <div className="modal d-flex">
      <div className="page-content" style={{ width: "100%" }} />

      {/* Login Modal */}
      {activeModal === "login" && (
        <div id="loginModal" className="modal-dialog form-login form-sign login">
          <div className="main-inner">
            <form action="#" id="loginForm">
              <div className="modal-head">
                <h4 className="title">Sign In</h4>
              </div>
              <div className="modal-body">
                <div className={getFormGroupClass("username")}>
                  <label className="label bold">Username</label>
                  <input
                    className="form-control"
                    name="username"
                    type="text"
                    onChange={handleChange}
                    style={{ textTransform: "lowercase" }}
                  />
                  {renderError("username")}
                </div>
                <div className={getFormGroupClass("password")}>
                  <label className="label bold">Password</label>
                  <input className="form-control" name="password" type="password" onChange={handleChange} />
                  {renderError("password")}
                </div>
                {errors.general && <p className="error-message">{errors.general}</p>}
                {apiMessage && <p className="success-message">{apiMessage}</p>}
              </div>
              <div className="modal-foot align-center">
                <button type="button" className="btn-primary" onClick={submitLogin}>
                  <span className="text">Sign In</span>
                </button>
                <div className="form-group align-center">
                  <a className="modalSwitchBtn bold btn-outline-secondary" onClick={openSignup}>
                    Sign Up!
                  </a>
                  &nbsp;|&nbsp;
                  <a className="modalSwitchBtn bold" onClick={openForgotPassword}>
                    Forgot password?
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Register Modal */}
      {activeModal === "register" && (
        <div id="registerModal" className="modal-dialog form-login form-sign register">
          <div className="main-inner">
            <form action="#" id="registerForm">
              <div className="modal-head">
                <h4 className="title">Sign Up</h4>
              </div>
              <div className="modal-body">
                {/* Form steps */}
                {currentStep === 1 && (
                  <>
                    <div className={getFormGroupClass("username")}>
                      <label className="label bold">
                        Username<abbr title="Required">*</abbr>
                      </label>
                      <input
                        className="form-control"
                        name="username"
                        type="text"
                        placeholder="6-18 characters or numbers"
                        value={formData.username || ""}
                        onChange={handleChange}
                        style={{ textTransform: "lowercase" }}
                      />
                      {renderError("username")}
                    </div>
                    <div className={getFormGroupClass("password")}>
                      <label className="label bold">
                        Password<abbr title="Required">*</abbr>
                      </label>
                      <input
                        className="form-control"
                        name="password"
                        type="password"
                        placeholder="6-20 characters or numbers"
                        value={formData.password || ""}
                        onChange={handleChange}
                      />
                      {renderError("password")}
                    </div>
                    <div className={getFormGroupClass("confirm_password")}>
                      <label className="label bold">
                        Confirm Password<abbr title="Required">*</abbr>
                      </label>
                      <input
                        className="form-control"
                        name="confirm_password"
                        type="password"
                        value={formData.confirm_password || ""}
                        onChange={handleChange}
                      />
                      {renderError("confirm_password")}
                    </div>
                    <div className="form-group form-column">
                      <label className="label bold">
                        Currency<abbr title="Required">*</abbr>
                      </label>
                      <select name="currency" className="form-control" value={formData.currency || "BDT"} onChange={handleChange}>
                        <option value="BDT">BDT</option>
                        <option value="PKR">PKR</option>
                        <option value="INR">INR</option>
                      </select>
                      {renderError("currency")}
                    </div>
                  </>
                )}
                {currentStep === 2 && (
                  <>
                    <div className={getFormGroupClass("first_name")}>
                      <label className="label bold">First Name<abbr title="Required">*</abbr></label>
                      <input
                        className="form-control"
                        name="first_name"
                        type="text"
                        value={formData.first_name || ""}
                        onChange={handleChange}
                      />
                      {renderError("first_name")}
                    </div>
                    <div className={getFormGroupClass("last_name")}>
                      <label className="label bold">Last Name<abbr title="Required">*</abbr></label>
                      <input
                        className="form-control"
                        name="last_name"
                        type="text"
                        value={formData.last_name || ""}
                        onChange={handleChange}
                      />
                      {renderError("last_name")}
                    </div>
                    <div className={getFormGroupClass("dofb")}>
                      <label className="label bold">Date of Birth<abbr title="Required">*</abbr></label>
                      <input
                        className="form-control"
                        name="dofb"
                        type="date"
                        value={formData.dofb || ""}
                        onChange={handleChange}
                      />
                      {renderError("dofb")}
                    </div>
                  </>
                )}
                {currentStep === 3 && (
                  <>
                    <div className={getFormGroupClass("phone")}>
                      <label className="label bold">Phone<abbr title="Required">*</abbr></label>
                      <input
                        className="form-control"
                        name="phone"
                        type="text"
                        value={formData.phone || ""}
                        onChange={handleChange}
                      />
                      {renderError("phone")}
                    </div>
                    <div className={getFormGroupClass("email")}>
                      <label className="label bold">Email<abbr title="Required">*</abbr></label>
                      <input
                        className="form-control"
                        name="email"
                        type="email"
                        value={formData.email || ""}
                        onChange={handleChange}
                      />
                      {renderError("email")}
                    </div>
                    <div className={`form-group form-column ${errors.contract_type || errors.contract_value ? "is-invalid" : ""}`}>
                      <label className="label bold">Others</label>
                      <div className="media-box other">
                        <select
                          className="form-control"
                          name="contract_type"
                          onChange={handleChange}
                          value={formData.contract_type || ""}
                        >
                          <option value="" />
                          <option>QQ</option>
                          <option>Wechat</option>
                          <option>Skype</option>
                          <option>Zalo</option>
                          <option>Telegram</option>
                          <option>WhatsApp</option>
                          <option>KakaoTalk</option>
                          <option>Line</option>
                          <option>IMO</option>
                          <option>Viber</option>
                          <option>FBMessenger</option>
                          <option>FACEBOOK</option>
                          <option>GOOGLE</option>
                        </select>
                        <input
                          className="form-control"
                          name="contract_value"
                          type="text"
                          value={formData.contract_value || ""}
                          onChange={handleChange}
                        />
                      </div>
                      {renderError("contract_type") || renderError("contract_value")}
                    </div>
                    <div className="form-group form-column">
                      <label className="label bold">Referral Code</label>
                      <input
                        className="form-control"
                        name="referral_code"
                        type="text"
                        value={formData.referral_code || ""}
                        onChange={handleChange}
                      />
                      {renderError("referral_code")}
                    </div>
                  </>
                )}
              </div>
              <div className="modal-foot align-center">
                {currentStep > 1 && (
                  <button type="button" onClick={handlePrevious} className="btn-primary">
                    <span className="text">Previous</span>
                  </button>
                )}
                {currentStep < 3 ? (
                  <>
                  <button type="button" onClick={handleNext} className="btn-primary">
                    <span className="text">Next</span>
                  </button>
                  <button type="button" className="btn-primary btn-light" onClick={openLogin}>
                  <span className="text">Cancel</span>
                </button>
                  </>
                ) : (
                  <button type="button" onClick={submitSignup} className="btn-primary">
                    <span className="text">Sign Up</span>
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
	)}
		  
	  {/* otp_reset */}
      {activeModal === "otp_reset" && (
        <div id="registerModal" className="modal-dialog form-login form-sign register">
          <div className="main-inner">
            <form action="#" id="registerForm">
              <div className="modal-head">
                <h4 className="title">Set New Password</h4>
              </div>
			<div className="modal-body">
				{errors.general && <p className="error-message">{errors.general}</p>}
				{apiMessage && <p className="success-message">{apiMessage}</p>}
				<div className={getFormGroupClass("otp")}>
					<label className="label bold">
					OTP<abbr title="Required">*</abbr>
					</label>
					<input
					className="form-control"
					name="otp"
					type="number"
					placeholder="6 Digit OTP"
					value={formData.otp || ""}
					onChange={handleChange}
					style={{ textTransform: "lowercase" }}
					/>
					{renderError("otp")}
				</div>
				<div className={getFormGroupClass("password")}>
					<label className="label bold">
					Password<abbr title="Required">*</abbr>
					</label>
					<input
					className="form-control"
					name="password"
					type="password"
					placeholder="6-20 characters or numbers"
					value={formData.password || ""}
					onChange={handleChange}
					/>
					{renderError("password")}
				</div>
				<div className={getFormGroupClass("confirm_password")}>
					<label className="label bold">
					Confirm Password<abbr title="Required">*</abbr>
					</label>
					<input
					className="form-control"
					name="confirm_password"
					type="password"
					value={formData.confirm_password || ""}
					onChange={handleChange}
					/>
					{renderError("confirm_password")}
				</div>
              </div>
              <div className="modal-foot align-center">
                  <button type="button" onClick={postChangePassword} className="btn-primary">
                    <span className="text">Change Password</span>
                  </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Forgot Password Modal */}
      {activeModal === "forgotPassword" && (
        <div id="forgotPasswordModal" className="modal-dialog form-login form-sign">
          <div className="main-inner">
            <form action="#" id="forgotPasswordForm">
              <div className="modal-head">
                <h4 className="title">Forgot Password</h4>
              </div>
			<div className="modal-body">
				{errors.general && <p className="error-message">{errors.general}</p>}
				{apiMessage && <p className="success-message">{apiMessage}</p>}
                <div className={getFormGroupClass("email")}>
                  <label className="label bold">Email</label>
                  <input
                    className="form-control"
                    name="email"
                    type="email"
                    onChange={handleChange}
                  />
                  {renderError("email")}
                </div>
              </div>
              <div className="modal-foot align-center">
                <button type="button" className="btn-primary" onClick={submitForgotPassword}>
                  <span className="text">Submit</span>
                </button>
                <button type="button" className="btn-primary btn-light" onClick={openLogin}>
                  <span className="text">Cancel</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style>{`
        .invalid-feedback {
          color: #dc3545;
          font-size: 12px;
          margin-top: 4px;
        }
        .error-message {
          color: #dc3545;
          margin-top: 10px;
        }
        .success-message {
          color: #28a745;
          margin-top: 10px;
        }
        .is-invalid .form-control {
          border-color: #dc3545;
        }
      `}</style>
    </div>
  );
}

export default Login;
